import React from "react";
import { connect } from "react-redux";

import { Card, CardBody, Button } from "reactstrap";

// import ListEmptyComponent from "../../global/utils/ListEmptyComponent";
import { getFullPath } from "../MyProfile/index";
import Theme from "../../theme";

import { CardHeader, Row, Col } from "reactstrap";
//import { InnerHOC } from "../../global/HOComponet/innerPage";
import { getGuardian } from "./redux/action";
import {
  setNavigationParams,
  showModal,
  showPasswordOverlay,
} from "../../global/redux/action";
import Item from "./item";
class guardinList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.getGuardian();
  }

  render() {
    const { list, parentProfile } = this.props;

    return (
      <Card className="border-0 shadow border-purple">
        <CardHeader
          style={{
            background: Theme.colorPrimary,
          }}
        >
          <Row>
            <Col xs="12" md="12" className="my-auto">
              <div
                style={{
                  color: "white",
                  fontFamily: "baloo",
                  fontSize: "1.3em",
                }}
              >
                Guardian{" "}
                <Button
                  style={{ float: "right" }}
                  onClick={() => {
                    if (list.length < 2) {
                      this.props.setNavigationParams({});
                      this.props.history.replace("/addGuardian");
                    } else {
                      this.props.showModal(
                        "Success",
                        "You can't add more than two guardians.",
                        false,
                        () => {},
                        () => {}
                      );
                    }
                  }}
                >
                  Add
                </Button>
              </div>
            </Col>
          </Row>
        </CardHeader>

        <CardBody>
          {/* <Parent /> */}
          <Item
            item={{
              guardian_picture: getFullPath(
                this.props.constants,
                parentProfile.fatherPhoto
              ),
              guardian_mobile_no: parentProfile.fatherPhone,
              status: parentProfile.fatherPhotoApproved,
              guardian_name: parentProfile.fatherName,
              relation_to_child: "Father",
              isEditable: false,
            }}
          />
          <Item
            item={{
              guardian_picture: getFullPath(
                this.props.constants,
                parentProfile.motherPhoto
              ),
              guardian_mobile_no: parentProfile.motherPhone,
              status: parentProfile.motherPhotoApproved,
              relation_to_child: "Mother",
              guardian_name: parentProfile.motherName,
              isEditable: false,
            }}
          />

          {/* {Array.isArray(list) && list.length > 0 && ( */}
          <div>
            {list.map((item, index) => (
              <Item
                history={this.props.history}
                item={item}
                key={index}
                index={index}
              />
            ))}
          </div>
          {/* )} */}
        </CardBody>
      </Card>
    );
  }
}
const mapStateToProps = (state) => ({
  list: state.guardian.list || [],
  parentProfile: state.userState.parentProfile,
  constants: state.constants,
});

const mapDispatchToProps = (dispatch) => ({
  getGuardian: () => dispatch(getGuardian()),
  setNavigationParams: (params) => dispatch(setNavigationParams(params)),
  showModal: (type, message, isConfirm, onOkPressed, onCancelPressed) =>
    dispatch(showModal(type, message, isConfirm, onOkPressed, onCancelPressed)),
  showPasswordOverlay: (show, onSuccess) =>
    dispatch(showPasswordOverlay(show, onSuccess)),
});
export default connect(mapStateToProps, mapDispatchToProps)(guardinList);
